<template>
  <NuxtLayout>
    <section class="registrationCompleted__Header">
      <Flare :srcset="page.image" width="1920" :alt="page.image" />
      <div class="registrationCompleted__HeaderOverlay"></div>
      <div class="container">
        <h1 v-text="page.title" />
        <p v-text="page.description" />
        <Button type="nuxt-link" :to="link('LoyaltyDashboard')" negative medium>{{ $t('goToProfile') }}</Button>
      </div>
    </section>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });

  const props = defineProps({
    page: {
      type: Object
    }
  })
  
  const { link } = useSetup();

  useHead({
    bodyAttrs: {
      class: 'transparentHeader'
    }
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_registrationCompleted.scss');
</style>